import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '@shared/providers/utils.service';
import { ConfirmPasswordValidator } from '@shared/validators/confirm-password.validator';
import { ResetPasswordService } from './reset-password.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage implements OnInit {
  public passwordForm: FormGroup;
  public logo = environment.logo;
  public showPass = false;
  private token: string;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private resetPasswordService: ResetPasswordService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    this.passwordForm = this.initializeForm();
    this.token = this.activatedRoute.snapshot.paramMap.get('token');
    await this.verifyToken();
  }

  async verifyToken() {
    try {
      await this.utils.presentLoading(`${this.translate.instant('RESET_PASSWORD.VALIDATING_URL')}`);
      this.resetPasswordService.show(this.token);
    } catch (error) {
      console.error(error);
      if (error?.error?.code) {
        this.utils.showToast('', error.error.message);
      } else {
        this.utils.showToast('', `${this.translate.instant('RESET_PASSWORD.ERROR_VERIFYNG_TOKEN')}`);
      }

      this.router.navigateByUrl('/login');
    } finally {
      this.utils.dismissLoading();
    }
  }
  initializeForm() {
    return this.formBuilder.group({
      password: [
        '',
        Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(180)]),
      ],
      confirmPassword: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(180),
          ConfirmPasswordValidator.isValid,
        ]),
      ],
    });
  }

  get password() {
    return this.passwordForm.get('password');
  }

  get confirmPassword() {
    return this.passwordForm.get('confirmPassword');
  }

  async confirm(form: FormGroup) {
    if (form.invalid) {
      this.utils.validateAllFields(form);
      this.utils.showToast('', `${this.translate.instant('RESET_PASSWORD.CHECK_THE_FIELDS')}`);
    } else {
      const body = { token: this.token, newPassword: this.password.value };
      try {
        await this.utils.presentLoading();
        await this.resetPasswordService.forget(body);
        this.utils.showToast('', `${this.translate.instant('RESET_PASSWORD.YOUR_PASSWORD_HAS')}`);
        this.router.navigateByUrl('/login');
      } catch (error) {
        console.error(error);
        if (error?.error?.code) {
          this.utils.showToast('', error.error.message);
        } else {
          this.utils.showToast('', `${this.translate.instant('RESET_PASSWORD.ERROR_SENDING')}`);
        }
      } finally {
        this.utils.dismissLoading();
      }
    }
  }
}
